<template>
  <div class="columns">
    <div class="column is-narrow">
      <div class="card pdb-6px">
        <div class="card-content pd-10px">
          <div class="columns">
            <div class="column is-narrow zoom-06">
              <div class="reseauTempoImage"/>
            </div>
            <div class="column is-8">
              <p class="has-text-weight-bold is-size-6">
                {{ $t('gestionAffectation.informationReseau.title', {
                libelle: ligneCommande.libelle,
                anneeSemaine: ligneCommande.ligneReseau.anneeSemaine.toString().substr(4, 2),
                date: getDateDepart }) }}</p>
              <p class="has-text-default">
                {{ affectations.length > 1 ?
                $t('gestionAffectation.informationReseau.faceAffectees',
                { faceAffecte: affectations.length }) :
                $t('gestionAffectation.informationReseau.faceAffectee',
                { faceAffecte: affectations.length })}}
                {{ (ligneCommande.ligneReseau.qteFacesSouhaitees > 1 ?
                $t('gestionAffectation.informationReseau.facesVendues', {
                faceVendu: ligneCommande.ligneReseau.qteFacesSouhaitees }) :
                $t('gestionAffectation.informationReseau.faceVendue', { faceVendu:
                ligneCommande.ligneReseau.qteFacesSouhaitees })) }}
              </p>
              <p class="has-text-primary is-size-7">
                {{ getNumberRestriction() > 1
                ? $t('gestionAffectation.informationReseau.restrictions',
                { restriction: getNumberRestriction() }) :
                $t('gestionAffectation.informationReseau.restriction',
                { restriction: getNumberRestriction() }) }}
              </p>
            </div>
            <div class="column is-2 is-flex align-self-center has-text-centered pdl-0">
              <div class="columns is-multiline is-paddingless has-text-centered"
                   v-if="ligneCommande.ligneReseau.qteFacesSouhaitees - affectations.length > 0">
                <div>
                  <div class="column is-12 is-paddingless">
                    <p class="has-text-danger has-text-weight-bold is-size-4">
                      {{ ligneCommande.ligneReseau.qteFacesSouhaitees - affectations.length }}
                    </p>
                  </div>
                  <div class="column is-12 is-paddingless has-text-centered is-size-7">
                    <p class="has-text-danger">
                      {{ $t('gestionAffectation.informationReseau.faceAaffecter') }}
                    </p>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="column is-12">
                  <b-icon icon="checkbox-marked-circle" type="is-success" size="is-medium">
                  </b-icon>
                </div>
              </div>
            </div>
          </div>
          <div class="columns is-multiline">
            <qd-switch class="has-text-default column is-narrow pdt-0"
              :disabled = disabled
              @input="$emit('makeRecherche')"
              v-model="filtres.estAffecteReseau">
              {{ $t('gestionAffectation.informationReseau.afficherFaceReseau') }}
            </qd-switch>
            <qd-switch class="has-text-default column is-narrow pdt-0"
              :disabled = disabled
              @input="$emit('makeRecherche')"
              v-model="filtres.estAffecteLigneCommande">
              {{ $t('gestionAffectation.informationReseau.afficherFace') }}
            </qd-switch>
            <div class="column is-narrow pdt-0">
              <button class="button is-primary"
                @click="popUpInfoFaceIssuePartielle = true"
                :disabled = disabled>
                <b-icon icon="format-list-bulleted" type="is-white">
                </b-icon>
                <span class="has-text-white">
            {{$t('gestionAffectation.informationReseau.afficherFaceVentePartielle')}}
            </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="popUpInfoFaceIssuePartielle"
      width="75%"
      class="modal"
      has-modal-card>
      <pop-up-selection-face
        :ligneSelect="ligneCommande"
        :display-column-logistique="true"
        :is-detail="true"
        :inAffectation="true"
        :permissions="permissions"
        :typeDcf="typeDcf">
      </pop-up-selection-face>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import getDateWithAnneeSemaineAndJourDepart from '@/services/general/getDateWithAnneeSemaineAndJourDepart';
import formatDate from '@/services/general/formatDate';
import popUpSelectionFace from '@/components/devisCommandeFacture/facesSelectInReseauTempo/p_selectFaces';
import * as produitConf from '@/configuration/catalogue/produitConf';
import { get } from '@/api/produit/produitReseauLc';
import messageErreur from '@/services/general/messageErreur';

const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'affectationReseau',
  data() {
    return {
      popUpInfoFaceIssuePartielle: false,
    };
  },
  props: {
    ligneCommande: {
      required: true,
      type: Object,
    },
    affectations: {
      required: true,
      type: Array,
    },
    filtres: {
      required: true,
      type: Object,
    },
    permissions: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    typeDcf: {
      type: String,
      required: false,
    },
  },
  components: {
    popUpSelectionFace,
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    getNumberRestriction() {
      let nbRestriction = 0;
      this.affectations.forEach((affectation) => {
        if (affectation.restrictionsAffichage !== '') nbRestriction += 1;
      });
      return nbRestriction;
    },
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    getDateDepart() {
      return formatDate(getDateWithAnneeSemaineAndJourDepart(
        this.ligneCommande.ligneReseau.anneeSemaine,
        this.ligneCommande.ligneReseau.jourDepart,
      ));
    },
  },
  async mounted() {
    if (this.ligneCommande
      .produit?.supportCommercial?.categorieVente !== produitConf.CATEGORIE_REGROUPEMENT_LC
    || !this.ligneCommande.quantiteDispo) {
      return;
    }
    const loadingComponent = this.$buefy.loading.open();
    try {
      const response = await get(this.ligneCommande.produitId);
      const reseau = response.data.result;
      if (reseau.produitReseau.quantiteFaces) {
        this.ligneCommande.ligneReseau.qteFacesSouhaitees = reseau
          .produitReseau.quantiteFaces * this.ligneCommande.quantiteDispo;
      }
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
